import { Component } from '@verndale/core';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { isIE, debounce } from '../helpers';

class Module extends Component {
  setupDefaults() {
    if (isIE) return;
    gsap.registerPlugin(ScrollTrigger);

    this.dom = {
      imageCta: this.el.querySelector('.large-image-cta'),
      image: this.el.querySelector('.large-image-cta__image'),
      heading: this.el.querySelector('.large-image-cta__heading'),
      cards: [...this.el.querySelectorAll('.card')]
    };

    this.breakpoint = window.matchMedia('(min-width: 1280px)');
    this.isAnimationDisabled = this.dom.imageCta.dataset.animated === 'false';

    ScrollTrigger.matchMedia({
      '(min-width: 1280px)': this.isAnimationDisabled
        ? null
        : this.initParallax.bind(this),
      '(max-width: 1279px)': this.disableParallax.bind(this)
    });
  }

  addListeners() {
    if (isIE) return;

    window.addEventListener(
      'resize',
      debounce(() => {
        if (this.timeline && this.breakpoint.matches) {
          this.timeline.invalidate();
          gsap.set(this.dom.image, { alpha: 1, width: 'auto' });
          gsap.set(this.dom.heading, { alpha: 0, y: 50 });
        }
      }, 100)
    );
  }

  initParallax() {
    this.timeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
        end: 'top 15%',
        scrub: 1
      }
    });

    gsap.set(this.dom.heading, { alpha: 0, y: 50 });

    this.timeline
      .from(this.dom.image, { width: 0, duration: 2 })
      .to(this.dom.heading, { alpha: 1, y: 0, duration: 1 }, '+=1');

    this.dom.cards.forEach((card, index) => {
      gsap.set(card, { y: index ? 0 : -190 });
      gsap.from(card, {
        scrollTrigger: {
          trigger: card,
          end: 'top 30%',
          scrub: true
        },
        alpha: 0,
        y: index ? 70 : -50
      });
    });

    setTimeout(() => ScrollTrigger.refresh(), 0);
  }

  disableParallax() {
    gsap.set(this.dom.image, { alpha: 1, width: 'auto' });
    gsap.set(this.dom.heading, { alpha: 1, y: 0 });
    this.dom.cards.forEach(card => gsap.set(card, { alpha: 1, y: 0 }));
  }
}

export default Module;
